export default function updatePost(oldPosts, newPost) {
  return oldPosts.map((post) => (post.id === newPost.id ? newPost : post));
}
